/* 布局 */
//前台
import Layout from "@views/layout";

const questionnairetemplateRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
            path: "questionnairetemplate",
            name: "QUESTIONNAIRETEMPLATE",
            meta: {
                title: "调查问卷模板",
                sort: 1,
            },
            component: () => import("@views/business/questionnairetemplate/index.vue"),
            redirect: {
                name: "QUESTIONNAIRETEMPLATE_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "QUESTIONNAIRETEMPLATE_LIST",
                    meta: {
                        title: "调查问卷模板",
                        sort: 2,
                        keepAlive: true
                    },
                    component: () => import("@views/business/questionnairetemplate/list.vue"),
                },
                {
                    path: "add",
                    name: "QUESTIONNAIRETEMPLATE_ADD",
                    meta: {
                        title: "新增调查问卷模板表",
                        parentPath: '/business/questionnairetemplate/list',
                        operate: true,
                    },
                    component: () => import("@views/business/questionnairetemplate/form.vue"),
                },
                {
                    path: "edit",
                    name: "QUESTIONNAIRETEMPLATE_EDIT",
                    meta: {
                        title: "编辑调查问卷模板表",
                        parentPath: '/business/questionnairetemplate/list',
                        operate: true,
                    },
                    component: () => import("@views/business/questionnairetemplate/form.vue"),
                },
                {
                    path: "info",
                    name: "QUESTIONNAIRETEMPLATE_INFO",
                    meta: {
                        title: "详情",
                        parentPath: '/business/questionnairetemplate/list',
                        operate: true,
                    },
                    component: () => import("@views/business/questionnairetemplate/components/detail.vue"),
                }, 
            ],
        },


    ],
};

export default questionnairetemplateRouter;
